export default __webpack_public_path__ + "static/media/SteakandCheese.10a77066.jpg";